import { Box } from "@mui/material";
import AppHeaderBar from "components/AppHeaderBar/AppHeaderBar";

type Props = {
  children: React.ReactNode;
};
const BaseLayout: React.FC<Props> = ({ children }) => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column" }} data-testid="BaseLayout">
      <AppHeaderBar />
      {children}
    </Box>
  );
};

export default BaseLayout;
